export class AppointmentAccess {
    lastName: string = '';

    reference: string = '';
}

interface AccessApointmentFormOwnProps {
    model: AppointmentAccess;
    onSuccess: (model: AppointmentAccess) => void;
}

export type AccessAppointmentFormProps = AccessApointmentFormOwnProps;
